import React from "react";
import styled, { css } from "styled-components";
import { Label } from "components/bootstrap";
import { STORAGE_REPOSITORY_TYPE_LABELS } from "./types";
const RepositoryInfo = styled.div`
  min-width: 0;
`;
const RepositoryLabel = styled(Label)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.xs};
  `
);
const RepositoryDescription = styled.p(
  ({ theme, $isSelected }) => css`
    margin-bottom: 0;
    margin-top: ${theme.spacings.xs};
    font-size: ${theme.fonts.size.small};
    color: ${$isSelected ? theme.colors.variant.lightest.gray : theme.colors.variant.darker.gray};
  `
);
const STATUS_PRESENTATION = {
  ready: { label: "Ready", bsStyle: "success" },
  not_ready: { label: "Not Ready", bsStyle: "danger" },
  missing_credentials: { label: "Missing Credentials", bsStyle: "warning" },
  invalid_credentials: { label: "Invalid Credentials", bsStyle: "warning" },
  unknown: { label: "Checking\u2026", bsStyle: "default" }
};
const RepositoryOption = ({ repository, isSelected }) => {
  var _a, _b, _c;
  const status = (_b = STATUS_PRESENTATION[(_a = repository.status) != null ? _a : repository.ready ? "ready" : "not_ready"]) != null ? _b : STATUS_PRESENTATION.unknown;
  return /* @__PURE__ */ React.createElement(RepositoryInfo, null, repository.label, /* @__PURE__ */ React.createElement(RepositoryLabel, null, (_c = STORAGE_REPOSITORY_TYPE_LABELS[repository.type]) != null ? _c : repository.type), /* @__PURE__ */ React.createElement(RepositoryLabel, { bsStyle: status.bsStyle }, status.label), repository.description && /* @__PURE__ */ React.createElement(RepositoryDescription, { $isSelected: isSelected }, repository.description));
};
export default RepositoryOption;
